const SUPPORTED_LOCALES = ["de", "en"];

const COPY = {
  de: {
    join: "Join us!",
    placeholder: "Deine E-Mail",
    sending: "E-Mail wird gesendet...",
    submitLabel: "E-Mail senden",
    closeLabel: "Hinweis schließen",
    sent: "Danke – schau in dein Postfach.",
    alreadySent: "Fast geschafft – prüfe dein Postfach.",
    invalidEmail: "Bitte prüfe deine E-Mail-Adresse. Vielleicht hat sich ein Tippfehler eingeschlichen.",
    invalidRecipient: "Diese Adresse konnten wir nicht erreichen. Bitte prüfe sie noch einmal.",
    sendError: "Das hat gerade nicht geklappt. Versuch es bitte in einem Moment noch einmal."
  },
  en: {
    join: "Join us!",
    placeholder: "Your email",
    sending: "sending email...",
    submitLabel: "Send email",
    closeLabel: "Dismiss message",
    sent: "Thank you — please check your inbox.",
    alreadySent: "Almost there — please check your inbox.",
    invalidEmail: "Please check your email address. There may be a typo.",
    invalidRecipient: "We couldn't reach that address. Please double-check it.",
    sendError: "That didn't work just now. Please try again in a moment."
  }
};

function detectLocale(initialLocale) {
  if (SUPPORTED_LOCALES.includes(initialLocale)) return initialLocale;

  const pathLocale = window.location.pathname.split("/")[1];
  if (SUPPORTED_LOCALES.includes(pathLocale)) return pathLocale;

  const browserLocale = (navigator.language || "en").toLowerCase();
  return browserLocale.startsWith("de") ? "de" : "en";
}

function pillClasses(extra = "") {
  return [
    "min-w-[220px] max-w-[min(92vw,34rem)] rounded-full border border-white/10 bg-white/95 text-neutral-900 shadow-[0_12px_40px_rgba(0,0,0,0.25)] backdrop-blur px-3 py-2 sm:px-4 sm:py-3",
    extra
  ].join(" ");
}

function buttonArrow() {
  return `
    <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path fill-rule="evenodd" d="M3.25 10a.75.75 0 0 1 .75-.75h10.19l-3.72-3.72a.75.75 0 1 1 1.06-1.06l5 5a.75.75 0 0 1 0 1.06l-5 5a.75.75 0 0 1-1.06-1.06l3.72-3.72H4a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
    </svg>
  `;
}

function spinner() {
  return `
    <svg class="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle class="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path class="opacity-90" fill="currentColor" d="M12 2a10 10 0 0 1 10 10h-4a6 6 0 0 0-6-6V2Z"></path>
    </svg>
  `;
}

function joinMarkup(copy) {
  return `
    <button type="button" data-role="expand" class="${pillClasses("font-semibold transition hover:bg-white")}">
      ${copy.join}
    </button>
  `;
}

function formMarkup(copy, email = "", error = "") {
  const tooltip = error
    ? `<div class="absolute -top-16 left-1/2 w-max max-w-[min(88vw,28rem)] -translate-x-1/2 rounded-2xl bg-rose-500 px-4 py-2 text-sm font-medium text-white shadow-lg">${error}</div>`
    : "";

  return `
    <form data-role="form" class="relative ${pillClasses("flex items-center gap-2")}">
      ${tooltip}
      <input
        data-role="email"
        type="email"
        name="email"
        value="${escapeHtml(email)}"
        placeholder="${copy.placeholder}"
        aria-label="${copy.placeholder}"
        class="min-w-0 flex-1 border-0 bg-transparent px-2 text-sm outline-none ring-0 placeholder:text-neutral-500 focus:border-0 focus:outline-none focus:ring-0 focus-visible:outline-none sm:text-base"
        autocomplete="email"
        required
      />
      <button
        type="submit"
        aria-label="${copy.submitLabel}"
        class="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-neutral-900 text-white transition hover:bg-neutral-800"
      >
        ${buttonArrow()}
      </button>
    </form>
  `;
}

function loadingMarkup(copy) {
  return `
    <div class="${pillClasses("flex items-center justify-center gap-2 text-sm font-medium")}">
      ${spinner()}
      <span>${copy.sending}</span>
    </div>
  `;
}

function successMarkup(copy, message) {
  return `
    <div class="${pillClasses("flex items-center gap-2 text-sm font-medium text-neutral-900 sm:text-base")}">
      <span class="min-w-0 flex-1 text-center">${message}</span>
      <button
        type="button"
        data-role="dismiss-success"
        aria-label="${copy.closeLabel}"
        class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-neutral-600 transition hover:bg-black/5 hover:text-neutral-900"
      >
        <svg class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path d="M5.28 5.22a.75.75 0 0 1 1.06 0L10 8.94l3.66-3.72a.75.75 0 1 1 1.08 1.04L11.06 10l3.68 3.74a.75.75 0 0 1-1.08 1.04L10 11.06l-3.66 3.72a.75.75 0 0 1-1.08-1.04L8.94 10 5.28 6.26a.75.75 0 0 1 0-1.04Z" />
        </svg>
      </button>
    </div>
  `;
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function render(root, state) {
  const copy = COPY[state.locale];
  const mount = root.querySelector('[data-role="mount"]') || root;

  switch (state.mode) {
    case "form":
      mount.innerHTML = formMarkup(copy, state.email, state.error);
      mount.querySelector('[data-role="email"]')?.focus();
      mount.querySelector('[data-role="email"]')?.select();
      break;
    case "loading":
      mount.innerHTML = loadingMarkup(copy);
      break;
    case "success":
      mount.innerHTML = successMarkup(copy, state.message);
      break;
    case "dismissed":
      mount.innerHTML = "";
      break;
    default:
      mount.innerHTML = joinMarkup(copy);
      break;
  }
}

function reasonMessage(locale, reason) {
  const copy = COPY[locale];

  switch (reason) {
    case "invalid_recipient":
      return copy.invalidRecipient;
    case "invalid_email":
      return copy.invalidEmail;
    default:
      return copy.sendError;
  }
}

async function submitEmail(root, state, email) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");
  state.mode = "loading";
  state.email = email;
  state.error = "";
  render(root, state);

  try {
    const response = await fetch(root.dataset.submitPath, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-csrf-token": csrfToken || ""
      },
      body: JSON.stringify({ email, locale: state.locale })
    });

    const payload = await response.json();

    if (response.ok && payload.status === "sent") {
      state.mode = "success";
      state.message = COPY[state.locale].sent;
      render(root, state);
      return;
    }

    if (response.ok && payload.status === "already_sent") {
      state.mode = "success";
      state.message = COPY[state.locale].alreadySent;
      render(root, state);
      return;
    }

    state.mode = "form";
    state.error = reasonMessage(state.locale, payload.reason);
    render(root, state);
  } catch (_error) {
    state.mode = "form";
    state.error = COPY[state.locale].sendError;
    render(root, state);
  }
}

export function initEmailRegistrationCTA() {
  const root = document.querySelector("[data-email-registration]");
  if (!root) return;
  if (root.dataset.initialized === "true") return;

  root.dataset.initialized = "true";
  root.dataset.submitPath = root.dataset.submitPath || "/api/email-registration";

  const state = {
    locale: detectLocale(root.dataset.locale),
    mode: "collapsed",
    email: "",
    error: "",
    message: ""
  };

  render(root, state);

  root.addEventListener("click", (event) => {
    const dismiss = event.target.closest('[data-role="dismiss-success"]');
    if (dismiss) {
      state.mode = "dismissed";
      render(root, state);
      return;
    }

    const expand = event.target.closest('[data-role="expand"]');
    if (!expand) return;

    state.mode = "form";
    state.error = "";
    render(root, state);
  });

  root.addEventListener("submit", (event) => {
    const form = event.target.closest('[data-role="form"]');
    if (!form) return;

    event.preventDefault();
    const email = form.querySelector('[data-role="email"]')?.value?.trim() || "";
    submitEmail(root, state, email);
  });
}
